import { useEffect, useState } from "react"
import { api } from "@lib/orpc-client"

export type BalanceResponse = {
    confirmed_balance: number | 'unavailable'
    legacy_balance: number | 'unavailable'
    new_balance: number | 'unavailable'
}

export type Balance = {
    confirmed_balance: number | 'unavailable'
    legacy_balance: number | 'unavailable'
    new_balance: number | 'unavailable'
}

const useBalance = () => {
    const [data, setData] = useState<Balance | undefined>(undefined)
    const [isLoading, setIsLoading] = useState(true)
    const [error, setError] = useState<unknown>(undefined)

    useEffect(() => {
        let cancelled = false
        setIsLoading(true)
        setError(undefined)
        api.wallet.balance({})
            .then((response: BalanceResponse) => {
                if (cancelled) return
                setData({
                    confirmed_balance: response.confirmed_balance,
                    legacy_balance: response.legacy_balance,
                    new_balance: response.new_balance
                })
            })
            .catch(() => {
                if (cancelled) return
                setData({
                    confirmed_balance: 'unavailable',
                    legacy_balance: 'unavailable',
                    new_balance: 'unavailable'
                })
            })
            .finally(() => {
                if (cancelled) return
                setIsLoading(false)
            })
        return () => {
            cancelled = true
        }
    }, [])

    return {
        data,
        isLoading,
        error
    }
}

export default useBalance
